import React from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { Add, DeleteOutline } from "@mui/icons-material";

const LeadTypes = ({ formData, setFormData, setIsChanged }: any) => {
  const tableHeadings = [
    { label: "Dropdown Text", align: "center" },
    { label: "Description", align: "center" },
    { label: "Action", align: "center" },
  ];

  const smallInputSX = {
    "& .MuiInputBase-input": {
      padding: "2px 6px !important",
      fontSize: "14px",
      height: "30px",
      boxSizing: "border-box",
    },
  };

  const smallSelectSX = {
    "& select": {
      padding: "2px 6px !important",
      fontSize: "14px",
      height: "26px",
    },
  };

  const LeadType = formData?.lead_types?.length
    ? formData.lead_types
    : [
        {
          name: "",
          description: "",
          is_editable: true,
          is_default: false,
          is_deletable: true,
          is_delete: false,
        },
      ];

  const handleInputChange = (
    index: number,
    field: string,
    value: string | boolean
  ) => {
    const updated = LeadType.map((item: any) => ({ ...item }));
    updated[index][field] = value;

    setFormData((prev: any) => ({
      ...prev,
      lead_types: updated,
    }));

    setIsChanged(true);
  };

  const handleAddRow = () => {
    const updated = [
      ...LeadType,
      {
        name: "",
        description: "",
        is_editable: true,
        is_deletable: true,
        is_default: false,
        is_delete: false,
      },
    ];

    setFormData((prev: any) => ({
      ...prev,
      lead_types: updated,
    }));
    setIsChanged(true);
  };

  const handleDelete = (index: number) => {
    const updated = LeadType.filter((_: any, i: number) => i !== index);

    if (updated.length === 0)
      updated.push({
        name: "",
        description: "",
        is_editable: true,
        is_deletable: true,
        is_default: false,
        is_delete: false,
      });

    setFormData((prev: any) => ({
      ...prev,
      lead_types: updated,
    }));

    setIsChanged(true);
  };

  return (
    <Grid item xs={12} md={12}>
      <Paper
        sx={{
          p: 2,
          borderRadius: "16px",
          backgroundColor: "#f8f9fa",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: 600,
            color: "#02906F",
            mb: 2,
            fontSize: "1rem",
          }}
        >
          Lead Types
        </Typography>

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "12px",
            overflowX: "auto",
            maxHeight: 350,
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  background: "#02906F",
                  "& th": {
                    color: "#fff",
                    fontWeight: 600,
                    textAlign: "center",
                    padding: "10px",
                  },
                }}
              >
                {tableHeadings.map((h, i) => (
                  <TableCell key={i}>{h.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {LeadType.map((row: any, index: number) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": { backgroundColor: "#e9f6f3" },
                    transition: "background 0.3s",
                  }}
                >
                  {/* Dropdown Text */}
                  <TableCell sx={{ textAlign: "center", padding: "4px 16px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      value={row.name}
                      disabled={!row?.is_editable}
                      onChange={(e) =>
                        handleInputChange(index, "name", e.target.value)
                      }
                      placeholder="Enter dropdown text"
                      sx={smallInputSX}
                    />
                  </TableCell>

                  {/* Description */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      padding: "4px 6px",
                      width: "60%",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      value={row.description}
                      disabled={!row?.is_editable}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                      placeholder="Enter description"
                      sx={smallInputSX}
                    />
                  </TableCell>

                  {/* Action */}
                  <TableCell sx={{ textAlign: "center", padding: "4px 16px" }}>
                    {row?.is_deletable && (
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(index)}
                      >
                        <DeleteOutline />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Add Row Button */}
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="outlined"
            startIcon={<Add />}
            onClick={handleAddRow}
            sx={{
              textTransform: "capitalize",
              fontWeight: 500,
              px: 3,
              py: 0.5,
              borderRadius: "8px",
            }}
          >
            Add More
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
};

export default LeadTypes;
